import React, { useEffect } from "react";
import SvgIcn from "../../../data/IconCompo";
import PropTypes from "prop-types";

const PlatformSelector = ({
  platforms = [],
  selectedPlatforms = [],
  onChange,
  error,
  category,
}) => {
  return (
    <>
      <div className="platform-group">
        {platforms.map((platform) => (
          <label
            key={platform.value}
            className={`platform-option ${
              selectedPlatforms?.includes(platform.value) ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              name="platform"
              value={platform.value}
              checked={selectedPlatforms?.includes(platform.value)}
              onChange={() => onChange(platform.value)}
              style={{ display: "none" }}
            />
            {platform?.value && <SvgIcn name={platform.value} />}
          </label>
        ))}
      </div>
      {error && <div className="error-message">{error}</div>}
    </>
  );
};

PlatformSelector.propTypes = {
  platforms: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
    })
  ),
  selectedPlatforms: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};

PlatformSelector.defaultProps = {
  platforms: [],
  selectedPlatforms: [],
};

export default PlatformSelector;
